import { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import AuthContext from './providers/auth';
import PrivateRoutes from './routes/private';
import PublicRoutes from './routes/public';

import AppLoader from 'components/ui/AppLoader';
import AppReloader from 'components/ui/AppReloader';
import SnackbarNotification from 'components/ui/Snackbar/SnackbarNotification';

class App extends Component {
  static contextType = AuthContext;

  async componentDidMount() {
    this.context.fetchData();
  }

  render() {
    if (this.context.loading) {
      return <AppLoader />;
    }

    if (this.context.error) {
      return <AppReloader />;
    }

    return (
      <Router>
        {this.context.isAuthenticated ? <PrivateRoutes /> : <PublicRoutes />}
        <SnackbarNotification />
      </Router>
    );
  }
}

export default App;
